import { AUTH, LOGOUT, REPOPULATE, UPDATE_PROFILE } from '../constants/actionTypes';

const authReducer = (state = {authData: null}, action) => {

    switch (action.type) {

        case AUTH:

            localStorage.setItem('profile', JSON.stringify({...action?.data }));

            return {
                ...state,
                authData: action?.data
            }; 

        case LOGOUT:

            console.log('logout state invoked');

            localStorage.removeItem('profile');

            return {
                ...state,
                authData: null
            }

        case UPDATE_PROFILE:

            let newState = {
                ...state,
                authData: {
                    ...state.authData, 
                    result: {
                        ...state.authData.result,
                        ...action.data.result
                    }    
                }
            }

            localStorage.setItem('profile', JSON.stringify(newState.authData));

            return newState; 

        case REPOPULATE:

            return {
                ...state,
                authData: action?.data
            }; 

        default:
            return state; 
    }
}

export default authReducer; 